module.exports = __webpack_public_path__ + "media/assets/icons/zitensya_icon-6e67fc1d0206ff5f800b0c142fefee76.svg";